import Verification from "../verification/Verification";
import SailpointSuccessResponse from "../verification/Sailpoint/SuccessResponse";
import SailpointFailedResponse from "../verification/Sailpoint/FailedResponse";
import SailpointPendingResponse from "../verification/Sailpoint/PendingSession";
import SailpointCanceledResponse from "../verification/Sailpoint/CanceledSession";
import SailpointErrorResponse from "../verification/Sailpoint/ErrorResponse";
import SailpointRetryErrorResponse from "../verification/Sailpoint/RetryErrorResponse";
import SailpointPendingNonBiometricSession from "../verification/Sailpoint/PendingNonBiometric";
import WorkdaySuccessResponse from "../verification/Workday/SuccessResponse";
import WorkdayFailedResponse from "../verification/Workday/FailedResponse";
import WorkdayPendingResponse from "../verification/Workday/PendingSession";
import WorkdayCanceledResponse from "../verification/Workday/CanceledSession";
import WorkdayErrorResponse from "../verification/Workday/ErrorResponse";
import WorkdayRetryErrorResponse from "../verification/Workday/RetryErrorResponse";
import WorkdayPendingNonBiometricSession from "../verification/Workday/PendingNonBiometric";
import SalesforceSuccessResponse from "../verification/Salesforce/SuccessResponse";
import SalesforceFailedResponse from "../verification/Salesforce/FailedResponse";
import SalesforcePendingResponse from "../verification/Salesforce/PendingSession";
import SalesforceCanceledResponse from "../verification/Salesforce/CanceledSession";
import SalesforceErrorResponse from "../verification/Salesforce/ErrorResponse";
import SalesforceRetryErrorResponse from "../verification/Salesforce/RetryErrorResponse";
import SalesforcePendingNonBiometricSession from "../verification/Salesforce/PendingNonBiometric";
import ApiError from "./error/ApiError";
import TokenError from './error/TokenError';
import PageNotFound from "./error/PageNotFound";
import { source_system_mapping } from "./constant";

const sp = source_system_mapping['SYS03'];
const wd = source_system_mapping['SYS01'];  
const sf = source_system_mapping['SYS02'];

const routes = [
    {
      path: '/verify',
      element: <Verification />,
      exact: true,
    },
    {
      path: `/${sp}/successful`,
      element: <SailpointSuccessResponse />,
      exact: true,
    },
    {
      path: `/${sp}/failed`,
      element: <SailpointFailedResponse />,
      exact: true,
    },
    {
      path: `/${sp}/pending`,
      element: <SailpointPendingResponse />,
      exact: true,
    },
    {
      path: `/${sp}/canceled`,
      element: <SailpointCanceledResponse/>,
      exact: true
    },
    {
      path: `/${sp}/error`,
      element: <SailpointErrorResponse />,
      exact: true,
    },
    {
      path: `/${sp}/failed/retry`,
      element: <SailpointRetryErrorResponse />,
      exact: true,
    },
    {
      path: `/${sp}/pending-nonbiometric`,
      element: <SailpointPendingNonBiometricSession />,
      exact: true,
    },
    {
      path: `/${wd}/successful`,
      element: <WorkdaySuccessResponse />,
      exact: true,
    },
    {
      path: `/${wd}/failed`,
      element: <WorkdayFailedResponse />,
      exact: true,
    },
    {
      path: `/${wd}/pending`,
      element: <WorkdayPendingResponse />,
      exact: true,
    },
    {
      path: `/${wd}/canceled`,
      element: <WorkdayCanceledResponse/>,
      exact: true
    },
    {
      path: `/${wd}/error`,
      element: <WorkdayErrorResponse />,
      exact: true,
    },
    {
      path: `/${wd}/failed/retry`,
      element: <WorkdayRetryErrorResponse />,
      exact: true,
    },
    {
      path: `/${wd}/pending-nonbiometric`,
      element: <WorkdayPendingNonBiometricSession />,
      exact: true,
    },
    {
      path: `/${sf}/successful`,
      element: <SalesforceSuccessResponse />,
      exact: true,
    },
    {
      path: `/${sf}/failed`,
      element: <SalesforceFailedResponse />,
      exact: true,
    },
    {
      path: `/${sf}/pending`,
      element: <SalesforcePendingResponse />,
      exact: true,
    },
    {
      path: `/${sf}/canceled`,
      element: <SalesforceCanceledResponse/>,
      exact: true
    },
    {
      path: `/${sf}/error`,
      element: <SalesforceErrorResponse />,
      exact: true,
    },
    {
      path: `/${sf}/failed/retry`,
      element: <SalesforceRetryErrorResponse />,
      exact: true,
    },
    {
      path: `/${sf}/pending-nonbiometric`,
      element: <SalesforcePendingNonBiometricSession />,
      exact: true,
    },
    {
      path: '/error',
      element: <ApiError />,
      exact: true,
    },
    {
      path: '/unauthorized',
      element: <TokenError />,
      exact: true,
    },
    {
      path: '/page-not-found',
      element: <PageNotFound />,
      exact: true
    }
  ];
  
  export default routes;